@import '../../../globals/main.scss';

pn-profile-modal-customernumber {
}
.pn-profile-modal-customernumber-button {
  display: block;
  border: 0;
  margin: 0;
  background: #fff;
  cursor: pointer;
  appearance: none;
  border: 0;
  outline: 0;
  padding: 0.8rem;
  font-weight: 400;
  font-size: 1.4rem;
  border-radius: 0.8rem;
  line-height: 1.4;

  transition: background 0.15s ease;
  text-align: left;
  width: 100%;
  &:hover,
  &:focus,
  &:active {
    background: $blue25;
  }
}
